export const MAX_RECORDS = 25000;
export const MODAL_WIDTH = 800;
